export interface Clock {
  now(): number;
}

export const performanceClock: Clock = {
  now: () => performance.now(),
};

export function createManualClock(startMs = 0): Clock & { advance(ms: number): void; set(ms: number): void } {
  let current = startMs;
  return {
    now: () => current,
    advance(ms: number) {
      current += ms;
    },
    set(ms: number) {
      current = ms;
    },
  };
}
